import { GraphQLClient } from 'graphql-request'

class Storefront {
  constructor () {
    this.client = new GraphQLClient(`https://${__GLOBAL__.shopHandle}.myshopify.com/api/${__GLOBAL__.apiVersion}/graphql.json`, {
      headers: {
        'X-Shopify-Storefront-Access-Token': __GLOBAL__.storefrontToken,
        'Content-Type': 'application/json'
      }
    })
  }

  request (query, variables) {
    return this.client.request(query, variables)
  }
}

export default new Storefront()
